export default __webpack_public_path__ + "static/media/enderima6.107d097e.jpg";